import styled from 'styled-components'
import { Form } from 'formik'

export const StyledForm = styled(Form)`
	width: 100%;
	word-break: break-word;
`